import axios from 'axios';

import { AppDispatch } from '../../reducer/store';
import { getToken } from '../axiosToken';

import {
	reducerGetProjects,
	reducerGetProjectsFilters,
} from '../../reducer/projects/reducers/reducerProjectsList';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const actionGetProjectsList =
	(limit: any, offset: any) =>
	async (dispatch: AppDispatch, getState: () => any) => {
		const { token } = await getToken();
		axios.defaults.headers.common['Authorization'] = token;

		const store = getState();
		const filter = store.projects.projects.projectsInputValues;
		try {
			const response = await axios.post(`${BASE_URL}/json/projects/list`, {
				limit,
				offset,
				...filter,
			});
			dispatch(reducerGetProjects({ data: response.data }));
		} catch (e: any) {
			if (e.response.status === 401) {
				window.location.href = "/login";
			}
		}
	};

export const actionGetProjectsFilters = () => async (dispatch: AppDispatch) => {
	const { token } = await getToken();
	axios.defaults.headers.common['Authorization'] = token;

	const response = await axios.get(`${BASE_URL}/json/projects/list/filters`);
	dispatch(reducerGetProjectsFilters(response.data));
};
